import React from 'react';

import FavoriteCount from '../FavoriteCount';
import useFavoriteCountAll from './useFavoriteCountAll';

interface Props {}

const FavoriteCountAll: React.FC<Props> = () => {
    useFavoriteCountAll();

    return <FavoriteCount type="all" />;
};

export default FavoriteCountAll;
